module.exports = __webpack_public_path__ + "img/yslogo.2783949c.png";